import { useEffect, useState } from 'react';
import { prop } from 'ramda';
import { send } from 'server';
import { useAppSelector } from 'js/store/hooks';

export const useIsLoginDeviceSupported = () => {
    const casinoName = useAppSelector(prop('casinoName'));
    const [isLoginDeviceSupported, setIsLoginDeviceSupported] = useState(false);

    useEffect(() => {
        (async () => {
            try {
                const data = await send({
                    ID: 35757,
                    description: 'Get Two Factor Conf',
                    responses: [35758],
                    casinoName
                });

                setIsLoginDeviceSupported(data.data.twoFactorConf.loginDeviceSupported);
            } catch (error) {
                console.warn(error);
            }
        })();
    }, [casinoName]);

    return isLoginDeviceSupported;
};
